import { render } from "./accountVerification.vue?vue&type=template&id=644f2c1a&scoped=true"
import script from "./accountVerification.vue?vue&type=script&lang=js"
export * from "./accountVerification.vue?vue&type=script&lang=js"

import "./accountVerification.vue?vue&type=style&index=0&id=644f2c1a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-644f2c1a"]])

export default __exports__